import { FC } from "react";
import { Button } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import { LoadingButton } from "@mui/lab";
import { stylesGW } from "../grainWiseStylesMUIComponents";
import { LocationGrainTrackerValues } from "../../../redux/slices/grainTracker/grainTrackerTypes";

type GrainTrackerMenuButtonsParams = {
  t: (arg0: string) => string;
  theBinIsGood: (
    specie: number | undefined | null,
    storage: undefined | string | null,
    tonsCapacity: number | undefined | null,
  ) => boolean;
  specie: any;
  storage: string | undefined;
  tonsCapacity: number | undefined;
  updateBin: (token: string) => void;
  token: string;
  isAddingStorage: boolean;
  setToCancelEditAddStorage: () => void;
  setCriteriaValuesToDelete: (values: string[]) => void;
  resetAllotmentCriteria: () => void;
  deleteBin: (token: string) => void;
  editedLoading: boolean;
  exitEditBinMode: (
    locationGrainTrackerValues: LocationGrainTrackerValues,
  ) => void;
  locationGrainTrackerValues: LocationGrainTrackerValues;
  setCancelValuestoEditLocation: () => void;
};

const GrainTrackerMenuButtons: FC<GrainTrackerMenuButtonsParams> = ({
  t,
  theBinIsGood,
  specie,
  storage,
  tonsCapacity,
  updateBin,
  token,
  isAddingStorage,
  setToCancelEditAddStorage,
  setCriteriaValuesToDelete,
  resetAllotmentCriteria,
  deleteBin,
  editedLoading,
  exitEditBinMode,
  locationGrainTrackerValues,
  setCancelValuestoEditLocation,
}) => {
  return (
    <div className="ml-4 mb-3">
      <LoadingButton
        loading={editedLoading}
        variant="contained"
        sx={stylesGW.GrainTrackerMenuButtons.buttons}
        disabled={theBinIsGood(specie, storage, tonsCapacity)}
        onClick={() => {
          updateBin(token);
        }}
      >
        {t("Grain_tracker.validate-button")}
      </LoadingButton>
      <Button
        sx={stylesGW.GrainTrackerMenuButtons.buttons}
        //disabled={isAddingStorage}
        onClick={() => {
          setToCancelEditAddStorage();
          setCriteriaValuesToDelete([]);
          resetAllotmentCriteria();
          setCancelValuestoEditLocation();
          //exitEditBinMode(locationGrainTrackerValues);
        }}
      >
        {t("Grain_tracker.cancel-modification")}
      </Button>
      <Button
        sx={stylesGW.GrainTrackerMenuButtons.buttons}
        color="error"
        startIcon={<DeleteIcon />}
        onClick={() => {
          deleteBin(token);
          resetAllotmentCriteria();
        }}
      >
        {t("Grain_tracker.delete-button")}
      </Button>
    </div>
  );
};

export default GrainTrackerMenuButtons;
